define([], function() {
    'use strict';
    var validation = require('./validation');

    require('./rules/required');
    require('./rules/range');
    require('./rules/integer');
    require('./rules/regex');
    require('./rules/alpha');
    require('./rules/equality');

    return validation;
});



/*****************
 ** WEBPACK FOOTER
 ** ./components/core/src/js/validation/index.js
 ** module id = 1
 ** module chunks = 0
 **/